import { forwardRef } from 'react'

import { cn } from 'src/shared/utils/cn'

interface HexagonProps {
  size?: number
  color: string
  className?: string
  children?: React.ReactNode
}

export const Hexagon = forwardRef<SVGSVGElement, HexagonProps>(
  ({ size = 49, color, className, children, ...props }, ref) => {
    return (
      <div className={cn('relative flex items-center justify-center', className)}>
        <svg
          ref={ref}
          width={size}
          height={(size * 70) / 49}
          viewBox="0 0 49 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M48.677 33.8861C48.888 34.6137 48.888 35.3863 48.677 36.1139L42.2653 58.227C41.9819 59.2046 41.3365 60.0373 40.4606 60.5556L26.537 68.7946C25.2807 69.538 23.7193 69.538 22.463 68.7946L8.53942 60.5556C7.6635 60.0373 7.0181 59.2046 6.73467 58.227L0.322979 36.1139C0.112003 35.3863 0.112003 34.6137 0.322979 33.8861L6.73467 11.773C7.0181 10.7954 7.6635 9.96272 8.53942 9.44441L22.463 1.20538C23.7193 0.461992 25.2807 0.46199 26.537 1.20537L40.4606 9.44441C41.3365 9.96272 41.9819 10.7954 42.2653 11.773L48.677 33.8861Z"
            fill={color}
            fillOpacity="0.4"
          />
        </svg>
        {children && <div className="absolute">{children}</div>}
      </div>
    )
  },
)

Hexagon.displayName = 'Hexagon'
